import { ENDPOINT } from "services/axios/constants/endpoints";
import { HTTPMethods } from "services/axios/types/http";
import { getDataFromRequest } from "services/axios/utility/helper";
import { AppThunk } from "services/redux/rootReducer";

const rebuildSite = (): AppThunk<Promise<void>> => async () => {
    return await getDataFromRequest(
        ENDPOINT.GITHUB_API.TRIGGER_REPO_DISPATCH,
        HTTPMethods.POST,
        process.env.REACT_APP_GITHUB_TOKEN,
        { ref: "main" },
        {
            headers: {
                "Content-Type": "application/vnd.github+json",
            },
        },
        false,
        true
    );
};

export default rebuildSite;
